<!--
 * @Author: your name
 * @Date: 2022-02-28 11:05:33
 * @LastEditTime: 2022-03-07 09:42:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cacaclo_front_end\src\views\publish\productList\components\batchTasks.vue
-->
<template>
    <div v-loading="loading" class="wish-tasks">
        <!-- <h3 style="margin: 14px 0">{{ $t('batchTasks.batchTasks')}}</h3> -->
        <div class="head-title f-b-c">
          <div class="title">{{ $t('Publish.BatchTasks.Index.ListingQueue') }}</div>
          <div class="back f--c pointer" @click="$router.back()">
            <i class="iconfont icon-a-arrow-left-s-line2" style="font-size:18px"></i>
            <div style="font-size:16px;margin-left:4px">{{ $t('Publish.BatchTasks.Index.Back') }}</div>
          </div>
        </div>
        <div class="wish-tasks-content bg-white">
            <div class="f-b head">
                <div class="f--c">
                    <el-select v-model="searchParams.platformCode" size="small" style="width: 140px;margin-right: 10px" @change="platformChange">
                        <el-option v-for="item in platformOptions" :key="item.platformCode" :label="item.platformName" :value="item.platformCode"></el-option>
                    </el-select>
                    <el-select v-model="searchParams.storeIds" size="small" style="width: 200px;margin-right: 10px" :placeholder="$t('productList.selectProductStatus')" clearable multiple :collapse-tags="true" @change="resetPage">
                        <el-option v-for="item in storeSelectList" :key="item.storeId" :label="item.storeName" :value="item.storeId"></el-option>
                    </el-select>
                    <el-select v-model="searchParams.processStatusList" size="small" style="width: 198px;margin-right: 10px" :placeholder="$t('productList.selectPublishStatus')" multiple :collapse-tags="true" clearable @change="resetPage">
                        <el-option :value="0" :label="$t('Publish.BatchTasks.Index.Pending')"></el-option>
                        <el-option :value="1" :label="$t('Publish.BatchTasks.Index.Processing')"></el-option>
                        <el-option :value="2" :label="$t('Publish.BatchTasks.Index.Completed')"></el-option>
                    </el-select>
                    <el-popover placement="top" width="400" trigger="click">
                      <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="searchParams.taskNos" @blur="taskNosBlur"></el-input>
                      <el-input :placeholder="$t('batchTasks.contentPlaceholder')" size="small" style="width: 450px" class="searchInput" v-model="taskNosOut" slot="reference"></el-input>
                    </el-popover>
                    <el-button icon="el-icon-search" type="success" size="small" class="searchButton" @click="resetPage"></el-button>
                </div>
            </div>
            <div v-if="tableData.length">
              <el-table :data="tableData" style="width: 100%;padding:0 20px" row-key="id" ref="tableData">
                  <el-table-column prop="taskNo" :label="$t('batchTasks.Number')" align="center"></el-table-column>
                  <el-table-column :label="$t('batchTasks.StoreInformation')" align="center">
                      <template slot-scope="scope">
                      <div class="f-a">
                          <div class="f">
                          <img src="@/assets/img/shopify-store.png" style="width: 20px;height: 20px;margin-right: 4px" v-if="scope.row.platformCode.toUpperCase() === 'SP'">
                          <img src="@/assets/img/dianjiang11.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'DJ'">
                          <img src="@/assets/img/woocommerce.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'WC'">
                          <img src="@/assets/img/shopLine-store.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'SL'">
                          <img src="@/assets/img/tiktok.png" style="width: 20px;height: 20px;margin-right: 4px" v-else-if="scope.row.platformCode.toUpperCase() === 'TT'">
                          {{ scope.row.storeName }}
                          </div>
                      </div>
                      </template>
                  </el-table-column>
                  <el-table-column :label="$t('batchTasks.ItemNo')" align="center">
                      <template slot-scope="scope">
                      <div style="text-align: center">
                          <el-popover placement="top" width="200" trigger="hover">
                              <div style="max-height: 300px;overflow-y: scroll;">
                                  <div v-for="spu in scope.row.spu.split(',')" :key="spu">{{ spu }}</div>
                              </div>
                              <div slot="reference">{{ scope.row.spu.split(',')[0] || '' }}</div>
                          </el-popover>
                          <div style="color: #99C41C; cursor: pointer;">
                              {{ scope.row.prePublishAllNum }}  {{ $t('batchTasks.data') }} <i class="el-icon-arrow-right"></i>
                          </div>
                      </div>
                      </template>
                  </el-table-column>
                  <el-table-column prop="price" :label="$t('batchTasks.PublicationSituation')" align="center" width="260">
                      <template slot-scope="scope">
                          <div class="PublicationSituation">
                              <div @click="situationNavigate('FailedToLoad', scope.row)" v-if="scope.row.loadFailNum">
                                  <span>{{ $t('batchTasks.FailedToLoad') }}:</span> <span style="color: red;">{{ scope.row.loadFailNum }}</span>
                              </div>
                              <div @click="situationNavigate('success', scope.row)" v-if="scope.row.publishSuccessNum">
                                  <span>{{ $t('batchTasks.Success') }}:</span> <span style="color: #99C41C;">{{ scope.row.publishSuccessNum }}</span>
                              </div>
                              <div @click="situationNavigate('uploading', scope.row)" v-if="scope.row.publishingNum">
                                  <span>{{ $t('batchTasks.uploading') }}:</span> <span style="color: #99C41C;">{{ scope.row.publishingNum }}</span>
                              </div>
                              <div @click="situationNavigate('ListingFailed', scope.row)" v-if="scope.row.publishFailNum">
                                  <span>{{ $t('batchTasks.ListingFailed') }}:</span> <span style="color: red;">{{ scope.row.publishFailNum }}</span>
                              </div>
                          </div>
                      </template>
                  </el-table-column>
                  <el-table-column prop="processStatus" :label="$t('batchTasks.Status')" align="center">
                      <template slot-scope="scope">{{ processStatusObj[scope.row.processStatus]}}</template>
                  </el-table-column>
                  <el-table-column prop="createDate" :label="$t('batchTasks.CreationTime')" align="center">
                      <template slot-scope="scope">{{ scope.row.createDate | timeToString}}</template>
                  </el-table-column>
              </el-table>
              <div style="text-align: right;padding:16px;">
                  <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[20, 50, 100, 200]"
                    :total="total"
                    class="myPagination"
                    :current-page.sync="searchParams.pageNumber"
                    :page-size="searchParams.pageSize"
                    @current-change="pageCurrentChange"
                    @size-change="pageSizeChange"/>
              </div>
            </div>
            <div v-else class="f--c" style="min-height:600px">
              <tableEmpty></tableEmpty>
            </div>
        </div>
        <failedToLoadList ref="failedToLoadList"></failedToLoadList>
    </div>
</template>

<script>
import API from '@/api'
import failedToLoadList from './components/failedToLoadList.vue'
import tableEmpty from '@/components/common/tableEmpty.vue'
export default {
  components: {
    failedToLoadList, tableEmpty
  },
  data() {
    return {
      storeSelectList: [],
      searchParams: {
        platformCode: 'DJ',
        storeIds: [],
        taskNos: undefined,
        pageNumber: 1,
        pageSize: 20,
        processStatusList: []
      },
      total: 0,
      tableData: [],
      selectionRowKey: [],
      selectAll: false,
      loading: false,
      taskNosOut: ''
    }
  },
  computed: {
    platformOptions() {
      if (!this.$store.state.common.platformOptions.length) this.$store.dispatch('common/getPlatformOptions')
      return this.$store.state.common.platformOptions.filter(e => e.platformCode !== 'KA')
    },
    processStatusObj() {
      const obj = {
        0: this.$t('batchTasks.Pending'),
        1: this.$t('batchTasks.Processing'),
        2: this.$t('batchTasks.Completed')
      }
      return obj
    }
  },
  created() {
    if (this.$store.state.published.publishedListMoreParams.platformCode) {
      this.searchParams.platformCode = this.$store.state.published.publishedListMoreParams.platformCode
      this.searchParams.storeIds = this.$store.state.published.publishedListMoreParams.storeIds
    }
    this.orderGetAllStore(this.searchParams.platformCode)
    this.getList()
  },
  methods: {
    // 第一次加载时获取shopify店铺
    orderGetAllStore(platformCode) {
      return new Promise((resolve, reject) => {
        API.orderGetAllStore({ platformCode, userId: this.$store.state.common.userId, storeStatus: 1, authorizeStatus: 1 }).then(res => {
          this.storeSelectList = res.data
          resolve()
        }).catch(() => reject())
      })
    },
    platformChange() {
      this.searchParams.storeIds = []
      this.orderGetAllStore(this.searchParams.platformCode)
      this.resetPage()
    },
    pageCurrentChange(page) {
      this.searchParams.pageNumber = page
      this.getList()
    },
    getParams(publishedListMoreParams) {
      const params = Object.assign({}, this.searchParams, publishedListMoreParams)
      if (params.taskNos) params.taskNos = params.taskNos.split('\n')
      return params
    },
    async getList(publishedListMoreParams) {
      this.loading = true
      try {
        const params = this.getParams(publishedListMoreParams)
        let res = await API.getLoadPublishRecordList(params)
        this.tableData = res.data.list
        this.total = res.data.total
      } catch (error) {
        this.$message.error(error.data.message)
      }
      this.loading = false
    },
    situationNavigate(type, row) {
      switch (type) {
        case 'FailedToLoad':
          this.$refs.failedToLoadList.show(row)
          break
        case 'success':
          this.$store.commit('published/set', { publishedListMoreParams: { platformCode: row.platformCode, storeIds: [row.storeId] }})
          this.$router.push({
            path: '/publish/listings',
            query: {
              activeName: 'Published',
              taskNo: row.taskNo
            }
          })
          break
        case 'uploading':
          this.$store.commit('published/set', { publishedListMoreParams: { platformCode: row.platformCode, storeIds: [row.storeId] }})
          this.$router.push({
            path: '/publish/listings',
            query: {
              activeName: 'ListingQueue',
              taskNo: row.taskNo
            }
          })
          break
        case 'ListingFailed':
          this.$store.commit('published/set', { publishedListMoreParams: { platformCode: row.platformCode, storeIds: [row.storeId] }})
          this.$router.push({
            path: '/publish/listings',
            query: {
              activeName: 'ListingQueue',
              taskNo: row.taskNo
            }
          })
          break
        default:
          break
      }
    },
    resetPage() {
      this.searchParams.pageNumber = 1
      this.getList()
    },
    set(params) {
      Object.assign(this.searchParams, params)
      this.orderGetAllStore(this.searchParams.platformCode)
      this.getList()
    },
    taskNosBlur(value) {
      if (value.target.value) {
        this.taskNosOut = value.target.value.split('\n').join(',')
      } else {
        this.taskNosOut = ''
      }
    },
    pageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wish-tasks {
  padding: 20px 20px 20px 36px;
  min-width: 1200px;
  color: #303133;
  .head-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    .back {
      color: #909399;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .wish-tasks-content {
    .head {
      padding: 20px;
    }

    /deep/ .el-input__inner{
      border-radius: 2px;
    }
    /deep/ .el-input-group--append .el-input__inner {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
    /deep/ .el-button {
      border-radius: 2px;
    }
  }
}

.inputGroup {
    width: 450px;
    /deep/.el-input__inner {
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
    }
    /deep/.el-input-group__append {
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        background-color: rgba(153, 196, 28, 0.2);
    }
}
.PublicationSituation {
    >div {
        margin-right: 8px;
        cursor: pointer;
    }
}
.searchButton {
  background-color: #F5F7FA; // #cce28e;
  color: #303133; //#fff
  border-color: #DCDFE6; // #cce28e;
  border-left: 0;
  width: 50px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}
.searchInput {
  /deep/input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
